export default "__VITE_ASSET__Dyceg1W___"